import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const EmitedDebinTitleColumns = () => (
    <>
        <GridTable.Data alignX="center">
            <I18n component="span" id="debin.expirery.date" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="debin.seller" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="debin.dateExpitation" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="debin.amount" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="debin.status" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="debin.type" />
        </GridTable.Data>
        <GridTable.Data alignX="center" />
    </>
);
export default EmitedDebinTitleColumns;
